import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Form, Input, notification, Select, } from 'antd'
import { COLOR, FONT } from '../constants';
import useResponsive from '../hooks/useResponsive'
import styled from 'styled-components'
import * as Service from '../core/Service';
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { useWallet } from '@solana/wallet-adapter-react';


const StyledFormContainer = styled.div`
  .ant-form-item-explain-error {
    text-align: start;
    font-family: Space Grotesk !important;
    font-size: 12px;
  }
  .ant-form-item-label {
    padding: 0px;
  }
  .ant-form-item-label span {
    color: #777777;
    font-weight: 500 !important;
  }
  .ant-input:focus, .ant-input-focused {
    box-shadow: none;
  }
  .ant-input[disabled] {
    color: #000;
  }
`



const ConnectButton = styled(WalletMultiButton)`
  width: 100%;
  &:hover {
    background-color: ${COLOR.content} !important;
    border: 3px solid #000000 !important;
    box-shadow: 6px 7px 0px #000000;
    border-radius: 8px;
  }
  border: 3px solid transparent !important;
`

const StyledButton = styled(Button)`
  width: 100%;
  &:hover, :focus {
    background-color: ${COLOR.content} !important;
    border: 3px solid #000000 !important;
    box-shadow: 6px 7px 0px #000000;
    border-radius: 8px;
  }
  border: 3px solid transparent !important;
`

const StyledSelect = styled(Select)`
  .ant-select-selector {
    background-color: transparent !important;
    border: 1px solid #2a2a2a !important;
  }
`

const WhitelistForm = ({
  onFinish,
  form,
  loading
}) => {
  const { isMobile } = useResponsive()

  const wallet = useWallet();

  useEffect(() => {
    if (!wallet?.connected) return
    form.setFieldsValue({ wallet_address: wallet.publicKey.toString() })
  }, [wallet, form])

  return (
    <StyledFormContainer>
      <Form
        layout='vertical'
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={<span style={{ ...FONT.captionText }}>Your Name</span>}
          name="name"
          rules={[
            {
              required: true,
              message: 'Please input your name!',
            },
          ]}
        >
          <Input style={{ width: '100%', border: 0, borderBottom: '1px solid #000', background: 'none', outline: 0 }} />
        </Form.Item>

        <Form.Item
          label={<span style={{ ...FONT.captionText }}>Your Company</span>}
          name="company"

        >
          <Input style={{ width: '100%', border: 0, borderBottom: '1px solid #000', background: 'none', outline: 0 }} />
        </Form.Item>

        <Form.Item
          label={<span style={{ ...FONT.captionText }}>Your Email</span>}
          name="email"
          rules={[
            {
              required: true,
              type: 'email',
              message: 'Please input your email!',
            },
          ]}
        >
          <Input style={{ width: '100%', border: 0, borderBottom: '1px solid #000', background: 'none', outline: 0 }} />
        </Form.Item>

        <Form.Item
          label={<span style={{ ...FONT.captionText }}>Your Whatsapp</span>}
          name="whatsapp"
          rules={[
            {
              required: true,
              message: 'Please input your WhatsApp!',
            },
          ]}
          style={{ width: '100%' }}
        >
          <Input style={{ width: '100%', border: 0, borderBottom: '1px solid #000', background: 'none', outline: 0 }} />
        </Form.Item>

        <Row justify='space-between' align='middle'>
          <Col
            xs={wallet?.connected ? 24 : 14}
            sm={wallet?.connected ? 24 : 14}
            md={wallet?.connected ? 24 : 14}
            lg={wallet?.connected ? 24 : 14}
          >
            <Form.Item
              label={<span style={{ ...FONT.captionText }}>Your Solana Wallet Address</span>}
              name="wallet_address"
              rules={[
                {
                  required: true,
                  message: 'Please input your solana wallet address!',
                },
              ]}
            >
              <Input disabled style={{ width: '100%', border: 0, borderBottom: '1px solid #000', background: 'none', outline: 0 }} />
            </Form.Item>
          </Col>
          <Col
            xs={wallet?.connected ? 0 : 9}
            sm={wallet?.connected ? 0 : 9}
            md={wallet?.connected ? 0 : 9}
            lg={wallet?.connected ? 0 : 9}
          >
            {!wallet?.connected ?
              <ConnectButton
                style={isMobile ?
                  { ...FONT.smallContent, backgroundColor: COLOR.textSecondary, color: COLOR.secondary, height: 48, border: 0, borderRadius: 8, marginBottom: 20 }
                  : {
                    ...FONT.button, backgroundColor: COLOR.textSecondary, color: COLOR.secondary, height: 48, border: 0, borderRadius: 8, marginBottom: 20
                  }}
              >Connect Wallet</ConnectButton>
              : null}
          </Col>
        </Row>
        <Form.Item
          label={<span style={{ ...FONT.captionText }}>Your crypto experience level</span>}
          name="user_type"
          rules={[
            {
              required: true,
              message: 'Please input your crypto experience level!',
            },
          ]}
        >
          <StyledSelect placeholder="Select" style={{ marginTop: 10 }}>
            <Select.Option value={2}>I am a crypto native</Select.Option>
            <Select.Option value={1}>I am a crypto intermediate</Select.Option>
            <Select.Option value={0}>I am a crypto newbie</Select.Option>
          </StyledSelect>
        </Form.Item>
        <Form.Item
          label={<span style={{ ...FONT.captionText }}>Your preferred minting way</span>}
          name="preferred_minting_way"
          rules={[
            {
              required: true,
              message: 'Please input your crypto experience level!',
            },
          ]}
          initialValue={0}
        >
          <StyledSelect placeholder="Select" style={{ marginTop: 10 }}>
            <Select.Option value={0}>I want to mint it myself - send a whitelist token to my wallet</Select.Option>
            <Select.Option value={1}>I want an NFT directly - airdrop a Shiba9 NFT to my wallet</Select.Option>
          </StyledSelect>
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 0,
            span: 24,
          }}
        >
          <StyledButton type="primary" htmlType="submit"
            loading={loading}
            disabled={loading}
            style={{ ...FONT.button, backgroundColor: COLOR.textSecondary, color: COLOR.secondary, height: 48, border: 0, borderRadius: 8, marginTop: 20 }}
          >
            Submit
          </StyledButton>
        </Form.Item>
      </Form>
    </StyledFormContainer>
  )
}

export default WhitelistForm;